import { gql } from '@apollo/client';
import { ErrorMessageInfo, WarrantyInfoShared } from '@retainerclub/shared-api';

export default gql`
  mutation actionWarrantyStateReversal(
    $input: WarrantyStateReversalActionInput!
  ) {
    actionWarrantyStateReversal(input: $input) {
      clientMutationId
      success
      deletedProductionOrders
      errorMessages {
        ...ErrorMessageInfo
      }
      warranty {
        ...WarrantyInfoShared
      }
    }
  }
  ${WarrantyInfoShared}
  ${ErrorMessageInfo}
`;
